import { Dispatch } from 'react';
import { EVENT_URL, apiClient, apiErrorHandler } from 'src/app/common/network';
import {
  ContentUpsertRequest,
  EventContentListResponse,
  EventContentResponse,
  EventTemplateContentListParams,
  EventTemplateListResponse,
  EventTemplateResponse,
  TemplateUpsertRequest,
} from '../types/template-content-type';

export const getTitles = async (params?: EventTemplateContentListParams) => {
  return apiClient.get(`${EVENT_URL}/events/greeting-card/titles`, { params });
};

export const addTitle = async (data?: any) => {
  return apiClient.post(`${EVENT_URL}/events/greeting-card/titles`, data);
};

export const editTitle = async (data?: any) => {
  return apiClient.put(`${EVENT_URL}/events/greeting-card/titles`, data);
};

export const getTemplates = async (params?: EventTemplateContentListParams): Promise<EventTemplateListResponse> => {
  return apiClient.get(`${EVENT_URL}/events/greeting-card/templates`, { params });
};

export const addTemplate = async (data: TemplateUpsertRequest): Promise<EventTemplateResponse> => {
  return apiClient.post(`${EVENT_URL}/events/greeting-card/templates`, data);
};

export const editTemplate = async (data: TemplateUpsertRequest): Promise<EventTemplateResponse> => {
  return apiClient.put(`${EVENT_URL}/events/greeting-card/templates`, data);
};

export const deleteTemplate = async (id?: String, dispatch?: Dispatch<any>): Promise<void> => {
  return apiClient
    .delete(`${EVENT_URL}/events/greeting-card/templates/${id}`)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const getContents = async (params?: EventTemplateContentListParams): Promise<EventContentListResponse> => {
  return apiClient.get(`${EVENT_URL}/events/greeting-card/contents`, { params });
};

export const addContent = async (data: ContentUpsertRequest): Promise<EventContentResponse> => {
  return apiClient.post(`${EVENT_URL}/events/greeting-card/contents`, data);
};

export const editContent = async (data: ContentUpsertRequest): Promise<EventContentResponse> => {
  return apiClient.put(`${EVENT_URL}/events/greeting-card/contents`, data);
};
